<template>
  <v-container grid-list-xl>
    <h2 class="display-1">Neues Prüfungsstück</h2>
    <v-alert :value="errorMessage" mb-4>{{ errorMessage }}</v-alert>
    <v-flex>
      <EditPruefungsstueckComponent
        :stueck="pruefungsstueck"
        :sets="sets"
        :standorte="standorte"
        @onSave="save"
      />
    </v-flex>
  </v-container>
</template>

<script>
import EditPruefungsstueckComponent from './EditPruefungsstueckComponent';

export default {
  name: 'CreatePruefungsstueckPage',
  data() {
    return {
      isLoading: true,
      sets: [],
      standorte: [],
      pruefungsstueck: {},
      errorMessage: ''
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        this.isLoading = true;

        const [sets, standorte] = await Promise.all([
          this.$http.get('pruefungsset'),
          this.$http.get('standort')
        ]);

        this.pruefungsstueck = {
          ID: 0,
          setID: parseInt(this.$route.query.setId) || 0,
          standortID: 0,
          PrfStkNr: '',
          Gesperrt: false
        };

        this.sets = sets.body;
        this.standorte = standorte.body;
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    save(item) {
      this.$http
        .post(`pruefungsstueck`, item)
        .then(resp => {
          this.$router.push({
            name: 'SingleSet',
            params: { setId: item.setID }
          });
        })
        .catch(err => {
          console.error(err);

          if (err.body.originalError) {
            this.errorMessage = err.body.originalError.info.message;
          }
        });
    }
  },
  components: {
    EditPruefungsstueckComponent
  }
};
</script>
